import React, { useEffect, useMemo, useState, useCallback, useRef,lazy } from 'react';
import { ConstantActions, LeadFormActions } from '../../../Services/_actions';
import { useLocation, useNavigate } from 'react-router-dom'; // Removed useParams
import {
    Box, Grid, Typography, Button, Popover, FormGroup, FormControlLabel,
    Checkbox, IconButton,
    MenuItem,
    Menu,
    TextField,
    CircularProgress,
    Chip,
    Modal,
    Tooltip
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import MoreVertIcon from '@mui/icons-material/MoreVert';
// Removed DynamicBreadcrumbs and HomeIcon as they seem less relevant in this nested context
import SearchBox from '../../FlowBuilder/Common/SearchBox/index.tsx';
import SearchableDropdown from '../../FlowBuilder/Common/SearchableDropdown/SearchableDropdown.tsx';
// Removed Recoil imports
import { convertToReadableFormat, dateFormate } from '../../../utils/helper.jsx'; // Removed generateFilterKey as we won't use Recoil cache keys
import Pagination from '../../FlowBuilder/Common/Pagination/index.tsx';
import CommonTable from '../../Shared/Tables/TableV1.tsx';
import DateRangeFilter from '../../Shared/DateRangeFilter/DateRangeFilter.tsx';
import ViewCommentModal from '../ViewCommentModal.tsx';
import FormDetailsModal from '../FormDetailsModal.tsx';
import DateTimeSubmitPicker from '../../Shared/DateTimePicker/index.tsx';
import ViewImagesModal from '../ViewImagesModal.tsx';
import AllUpdateStatusModal from '../AllUpdatedStatusModal.tsx';
import { MRT_SortingState } from 'material-react-table';
import { useSnackBar } from '../../FlowBuilder/Common/SnackBar/index.tsx'
import DynamicFilters from '../DynamicFilters.tsx'; // Assuming this doesn't rely on Recoil
import RefreshIcon from '@mui/icons-material/Refresh';
import ConfirmBox from '../../FlowBuilder/Common/ConfirmBox/index.tsx';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { campaignDataMapAtom } from '../../../Services/_states/index.js';
import { sortFieldsByEntity } from '../DynamicFormFields/helper.ts';
import { CallingModal } from '../../Modals/CallingModal/CallingModal.jsx';
const ModalForms = lazy(() => import('../../Shared/Modals/index.js'));

interface ChildCampaignLeadsProps {
    campaignId: string;
    leadFormId: string;
    dynamicFormFields?: any[];
    parentLead?: any;
    handleSelectRow: (row) => void;
    dynamicFormGroups?: any[];
    tabName?: string;
    showSparePartsInfo?: boolean;

};

interface FilterState {
    parent_lead_id?: string;
    campaign_id: string;
    leads_form_id: string;
    page: number;
    limit: number;
    search: string;
    status: string;
    statusObj: any | null;
    isPending: boolean;
    start_date: string;
    end_date: string;
    sort_by: string;
    sort_type: number;
    // Add phone_number filter
    phone_number?: string;
}

// --- Static Data ---
const staticFieldOptions = [
    'Initial Action Date', 'Last Action Date', 'Current Status', 'Next Status',
    'Next Action Date', 'Internal Comment',
];

// --- Helper Components ---
const CommentCell = ({ row }) => {
    const comment = row.original?.last_machadalo_comment?.comment || '';
    const [expanded, setExpanded] = React.useState(false);
    const handleToggle = () => setExpanded(!expanded);
    const previewLength = 30; // Changeable between 20–30 as needed
    const isLongComment = comment.length > previewLength;
    const visibleComment = expanded ? comment : comment.slice(0, previewLength);

    return (
        <Box>
            <div style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>
                {visibleComment}
                {!expanded && isLongComment && '...'}
            </div>
            {isLongComment && (
                <Box
                    sx={{ color: 'blue', cursor: 'pointer', mt: 0.5 }}
                    onClick={handleToggle}
                >
                    {expanded ? 'Show less' : 'Show more'}
                </Box>
            )}
        </Box>
    );
};

const ChildCampaignLeads: React.FC<ChildCampaignLeadsProps> = ({ campaignId, leadFormId, dynamicFormFields = [], dynamicFormGroups = [], parentLead = null, handleSelectRow, tabName = "Form Name Dashboard", showSparePartsInfo = false
}) => {
    const navigate = useNavigate();
    const leadActions = LeadFormActions();
    const constantActions = ConstantActions();
    const { showSnackBar } = useSnackBar();
    const [filters, setFilters] = useState<FilterState>({
        campaign_id: campaignId,
        leads_form_id: leadFormId,
        parent_lead_id: parentLead?.lead_id || '',
        page: 0,
        limit: 10,
        search: '',
        status: '',
        statusObj: null,
        isPending: false,
        start_date: '',
        end_date: '',
        sort_by: 'created_at',
        sort_type: -1,
        //  parent_lead_id: parentLead?.lead_id || '',

    });
    const [leadsData, setLeadsData] = useState<any[]>([]);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [uniqueCount, setUniqueCount] = useState<number>(0); // Might be less relevant when filtered by phone
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);
    const [selectedFields, setSelectedFields] = useState<any[]>([]);
    const [selectedStaticFields, setSelectedStaticFields] = useState<string[]>(staticFieldOptions);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [anchorStaticEl, setAnchorStaticEl] = useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const openStatic = Boolean(anchorStaticEl);
    const [statusList, setStatusList] = useState([]);
    const [statusFilters, setStatusFilters] = useState({
        active: { value: true },
        leadFormId: leadFormId,
    })
    const [dateRange, setDateRange] = useState({ startDate: null, endDate: null });
    const [openCommentModal, setOpenCommentModal] = useState(false);
    const [openFormDetailModal, setOpenFormDetailModal] = useState(false);
    const [openImageModal, setOpenImageModal] = useState(false);
    const [openUpdateStatusModal, setOpenUpdateStatusModal] = useState(false);
    const [selectedRow, setSelectedRow] = useState<any>({});
    const [sorting, setSorting] = useState<MRT_SortingState>([]);
    const [filterableFields, setFilterableFields] = useState<any>([]);
    const [confirmStatusOpen, setConfirmStatusOpen] = useState(false);
    const [confirmDateOpen, setConfirmDateOpen] = useState(false);
    const [pendingUpdate, setPendingUpdate] = useState < { id: number, status: string, status_id: string } | null > (null);
    const [pendingDateUpdate, setPendingDateUpdate] = useState < { id: number, date: string } | null > (null);
    const [confirmNextStatusOpen, setConfirmNextStatusOpen] = useState(false);
    const [pendingNextStatusUpdate, setPendingNextStatusUpdate] = useState<{ id: number, next_status: string } | null>(null);
    const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
    const [campaignDataMap, setCampaignDataMap] = useRecoilState(campaignDataMapAtom);
    const [openModal, setOpenModal] = useState(false);
    const [openMissingModal, setOpenMissingModal] = useState(false);
    const [showCallingModal, setShowCallingModal] = useState(false);

    const handleViewMoreClick = () => {
        setOpenModal(true); // Open the modal to view all data
    };

    const handleCloseModal = () => {
        setOpenModal(false); // Close the modal
    };
    // --- Data Fetching ---
    const fetchLeads = useCallback(async () => {
        if (!campaignId || !leadFormId) {
            setLeadsData([]);
            setTotalCount(0);
            setUniqueCount(0);
            return;
        }
        setIsLoading(true);
        setError(null);
        try {
            const currentFilters = {
                ...filters,
                campaign_id: campaignId,
                leads_form_id: leadFormId,
            };
            const res = await leadActions.getB2b2CLeads(currentFilters);
            if (res?.status === 200) {
                const data = res.data;
                const rows = Array.isArray(data?.data)
                    ? data?.data
                    : Array.isArray(data)
                        ? data
                        : data?.list || [];

                setLeadsData(rows);
                console.log(data, "datadata")
                setTotalCount(data?.count || 0);
                setUniqueCount(data?.unique_phone_count || 0);
            } else {
                throw new Error(res?.message || 'Failed to fetch leads');
            }
        } catch (err) {
            setError(err.message || 'An error occurred while fetching leads.');
            showSnackBar(err.message || 'Error fetching leads.', 'error');
            setLeadsData([]);
            setTotalCount(0);
            setUniqueCount(0);
        } finally {
            setIsLoading(false);
        }
    }, [campaignId, leadFormId, JSON.stringify(filters)]); // filters object stringified

    const entityColumns = selectedFields
        .filter(field => field?.key_type === "ENTITY" && field?.entityAliasName)
        .map(field => ({
            accessorKey: `data.${field?.alias_name}.${field?.entityAliasName}`,
            header: (
                <Tooltip title={`Data behalf of: ${convertToReadableFormat(field?.alias_name)}`}>
                    <span>{convertToReadableFormat(field?.entityAliasName)}</span>
                </Tooltip>
            ),
            Cell: ({ row }) => {
                let value = "-";
                try {
                    const dataItem = row?.original?.data?.find(d => d.alias_name === field?.alias_name);
                    value = dataItem?.value?.entity?.[field?.entityAliasName]?.toString() || '-';
                } catch { }
                return <>{value}</>;
            }
        }));

    const regularColumns = selectedFields
        .filter(field => field?.key_type !== "ENTITY")
        .map(field => ({
            accessorKey: `data.${field.alias_name}`,
            header: convertToReadableFormat(field?.alias_name),
            Cell: ({ row }) =>
                row.original?.data?.find(d => d.alias_name === field.alias_name)?.value?.toString() || '-',
        }));

    const dynamicColumns = [...entityColumns, ...regularColumns];


    const getStatusList = async (filterObj) => {
        try {
            const res: any = await leadActions.fetchStatusAndSubStatus(filterObj);
            if (res?.status === 200) {
                setStatusList([...res?.data]);
            }
        } catch (error) {
            console.warn(error);
        }
    };
    const getNextStatusByStatus = (status = "") => {
        const result: any = statusList?.find((item: any) => item?.status_name === status);
        return result?.substatuses || [];
    }
    const onCloseFormFieldsModal = (dynamicFormData, type = "") => {
        if (type === "update") {
            setLeadsData(prevLeads => prevLeads.map(lead =>
                lead?.lead_id === selectedRow?.lead_id ? {
                    ...lead,
                    data: dynamicFormData,
                } : lead
            ));
        } else if (type === "create") {
            fetchLeads();
        }
        setOpenFormDetailModal(false)
    }

    const handleUpdateNextStatus = (e, id) => {
        const updatedStatus = e?.name || ''; // Assuming 'name' is the key for next status options
        if (updatedStatus) {
            setPendingNextStatusUpdate({ id, next_status: updatedStatus });
            setConfirmNextStatusOpen(true);
        } else {
            console.warn("Next status cleared - handling not implemented.");
        }
    };

    const handleConfirmNextStatusUpdate = async (confirmed: boolean) => {
        if (!confirmed || !pendingNextStatusUpdate) {
            setConfirmNextStatusOpen(false);
            setPendingNextStatusUpdate(null);
            return;
        }
        const { id, next_status } = pendingNextStatusUpdate;
        const data = { id, next_status };
        setIsLoading(true);

        try {
            const res: any = await leadActions.updateLeadStatusDate(data);
            if (res?.status === 200) {
                setLeadsData(prevLeads => prevLeads.map(lead =>
                    lead.id === id ? {
                        ...lead,
                        next_status: {
                            ...(lead.next_status || {}), // Preserve other potential fields
                            status_name: next_status, // Update the status name
                        },
                    } : lead
                ));
                showSnackBar('Next status updated successfully.', 'success');
            } else {
                showSnackBar(res?.message || 'Failed to update next status.', 'error');
            }
        } catch (error: any) {
            showSnackBar(error?.message || 'Error while updating next status.', 'error');
        } finally {
            setPendingNextStatusUpdate(null);
            setConfirmNextStatusOpen(false);
            setIsLoading(false);
        }
    };

    // --- Event Handlers ---
    const handleDateRangeApply = (range) => {
        setDateRange(range);
        let startDate = range.startDate ? dateFormate(range.startDate, "YYYY-MM-DD") : '';
        let endDate = range.endDate ? dateFormate(range.endDate, "YYYY-MM-DD") : '';
        setFilters((prev) => ({
            ...prev, page: 0, start_date: startDate, end_date: endDate
        }));
    };

    const handleOpenPopover = (e) => setAnchorEl(e.currentTarget);
    const handleClosePopover = () => setAnchorEl(null);
    const handleOpenStaticPopover = (e) => setAnchorStaticEl(e.currentTarget);
    const handleCloseStaticPopover = () => setAnchorStaticEl(null);
    const handleFieldToggle = (field) => {
        setSelectedFields((prev) => {
            const existingField = prev.find((f) => f?.alias_name === field?.alias_name);
            if (existingField) {
                return prev.filter((f) => f?.alias_name !== field?.alias_name);
            } else {
                return [...prev, { ...field }];
            }
        });
    };
    const handleEntityFieldToggle = (field, entityField) => {
        setSelectedFields((prev) => {
            const existingEntityField = prev.find((f) => f?.entityAliasName === entityField);
            if (existingEntityField) {
                return prev.filter((f) => f?.entityAliasName !== entityField);
            } else {
                return [...prev, { ...field, entityAliasName: entityField, entityLabel: entityField }];
            }
        });
    };

    const handleStaticFieldToggle = (field) => setSelectedStaticFields((prev) => prev.includes(field) ? prev.filter(f => f !== field) : [...prev, field]);
    const handleChangePage = (_, newPage) => setFilters((prev) => ({ ...prev, page: newPage }));
    const handleChangeRowsPerPage = (e) => setFilters((prev) => ({ ...prev, limit: parseInt(e.target.value, 10) || 10, page: 0 }));
    const handleSearch = (query) => setFilters((prev) => ({ ...prev, page: 0, search: query }));

    // --- Update Handlers (Modify local state) ---
    const handleUpdate = (e, id) => {
        const selectedStatus = e?.status_name || '';
        if (selectedStatus) {
            setPendingUpdate({ id, status: selectedStatus, status_id: e?.status_id });
            setConfirmStatusOpen(true);
        }
    };

    const handleConfirmUpdate = async (confirmed: boolean) => {
        if (!confirmed || !pendingUpdate) {
            setConfirmStatusOpen(false);
            setPendingUpdate(null);
            return;
        }
        const { id, status, status_id } = pendingUpdate;
        const data = { id, status, status_id };
        setIsLoading(true);
        try {
            const res: any = await leadActions.updateLeadStatusDate(data);
            if (res?.status === 200) {
                // Update local state
                setLeadsData(prevLeads => {
                    const updatedLeads = prevLeads.map(lead =>
                        lead.id === id
                            ? { ...lead, last_status: { ...lead.last_status, status_name: status } }
                            : lead
                    );
                    const updatedLead = updatedLeads.find(lead => lead.id === id);
                    if (updatedLead) {
                        handleSelectRow(updatedLead);
                    }

                    return updatedLeads;
                });
                showSnackBar('Current status updated successfully!', 'success');
            } else {
                showSnackBar(res?.message || 'Failed to update current status.', 'error');
            }
        } catch (error: any) {
            showSnackBar(error?.message || 'Error while updating current status.', 'error');
        } finally {
            setPendingUpdate(null);
            setConfirmStatusOpen(false);
            setIsLoading(false);
        }
    };

    const handleConfirmDate = async (confirmed: boolean) => {
        if (!confirmed || !pendingDateUpdate) {
            setConfirmDateOpen(false);
            setPendingDateUpdate(null);
            return;
        }

        const { id, date } = pendingDateUpdate;
        const data = { id, next_action_date: date };
        setIsLoading(true);

        try {
            const res: any = await leadActions.updateLeadStatusDate(data);
            if (res?.status === 200) {
                // Update local state
                setLeadsData(prevLeads => prevLeads.map(lead =>
                    lead.id === id ? { ...lead, next_action_date: date } : lead
                ));
                showSnackBar('Next action date updated!', 'success');
            } else {
                showSnackBar(res?.message || 'Failed to update next action date.', 'error');
            }
        } catch (error: any) {
            showSnackBar(error?.message || 'Error while updating next action date.', 'error');
        } finally {
            setPendingDateUpdate(null);
            setConfirmDateOpen(false);
            setIsLoading(false);
        }
    };

    const confirmDeleteLead = async (confirmed: boolean) => {
        if (confirmed && selectedRow) {
            try {
                const res: any = await leadActions.deleteLeadV1(selectedRow);
                if (res?.status === 200) {
                    showSnackBar('Lead deleted successfully!', 'success');
                    const updateData = leadsData?.filter(item => item.lead_id !== selectedRow?.lead_id);
                    setLeadsData(updateData);
                }
                else {
                    showSnackBar('Failed to delete lead.', 'error');
                }
            } catch (error) {
                showSnackBar('Failed to delete lead.', 'error');
            } finally {
                setSelectedRow(null);
            }
        }
    }


    // Comment saving only updates local state now, API call happens in modal/parent if needed
    const handleSaveCommentLocally = (comment, id) => {
        setLeadsData(prevLeads => prevLeads.map(row =>
            row.id === id
                ? {
                    ...row,
                    last_machadalo_comment: {
                        ...(row.last_machadalo_comment || {}),
                        comment,
                    },
                }
                : row
        ));
        // showSnackBar('Comment updated locally!', 'info'); // Maybe less intrusive
    };

    // --- Column Definition ---
    const columns = useMemo(() => {
        const baseColumns = [
            {
                accessorKey: 'index',
                 header: 'S.No.', 
                 size: 100, 
                 muiTableHeadCellProps: {
        sx: {
          backgroundImage: 'linear-gradient(0deg, #3e59e3 35%, #5f76e8 100%)',
          color: 'white',
          fontWeight: '600',
            fontSize: '14px',
            fontFamily:'system-ui',
          paddingLeft: '35px !important', 
        },
      },
      muiTableBodyCellProps: {
        sx: {
          paddingLeft: '35px !important',
          backgroundColor: '#fafafa',
        }, enableSorting: false,
                Cell: ({ row }) => filters.page * filters.limit + row.index + 1
             } },
            {
                accessorKey: 'id', header: 'Lead Id',
                Cell: ({ row }) => {
                    return (
                        <Chip
                            label={row?.original?.lead_id || row?.original?.id}
                            color="primary"
                            size="small"
                            variant={
                                campaignDataMap[campaignId]?.parentLead?.lead_id === row?.original?.lead_id
                                    ? 'filled'
                                    : 'outlined'
                            }
                            onClick={() => {
                                handleSelectRow(row?.original)
                            }}
                        />


                    );
                },
            },
            // {
            //     accessorKey: 'phone_number',
            //     header: 'Phone Number',
            //     // Link might not be needed if these are child leads shown in edit context
            //     Cell: ({ row }: any) => row?.original?.phone_number,
            //     size: 120
            // },
        ];
        const dynamicColumns = selectedFields.map((field) => {
            if (field?.key_type === "ENTITY" && field?.selectedEntityFields?.length > 0 && field?.selectedEntityFields?.includes(field?.entityAliasName)) {
                return {
                    accessorKey: `data.${field?.alias_name}.${field?.entityAliasName}`,
                    // header: `${convertToReadableFormat(field?.alias_name)}.${convertToReadableFormat(field?.entityAliasName)}`,
                    header: (
                        <Tooltip title={`Data behalf of: ${convertToReadableFormat(field?.alias_name)}`}>
                            <span>{convertToReadableFormat(field?.entityAliasName)}</span>
                        </Tooltip>
                    ),

                    // Cell: ({ row }) => {
                    //     let value = ""
                    //     try {
                    //         value = row?.original?.data?.find((d) => d?.alias_name === field?.alias_name)?.value?.entity[field?.entityAliasName]?.toString() || '-';
                    //     } catch (error) {
                    //         console.error(error, "222222222222222222222222222222");
                    //     }
                    //     finally {
                    //         return <>{value}</>;
                    //     }
                    // }
                    Cell: ({ row }) => {
                        let value = "-";
                        try {
                            const dataItem = row?.original?.data?.find((d) => d?.alias_name === field?.alias_name);
                            if (dataItem?.value?.entity) {
                                value = dataItem.value.entity[field?.entityAliasName]?.toString() || '-';
                            }
                        } catch (error) {
                            console.error(error, "Error accessing entity field value");
                        }
                        return <>{value}</>;
                    }

                };
            } else {
                return {
                    accessorKey: `data.${field.alias_name}`, // For non-entity fields
                    header: convertToReadableFormat(field?.alias_name),
                    Cell: ({ row }) => row.original?.data?.find((d) => d.alias_name === field.alias_name)?.value?.toString() || '-',
                };
            }
        }).flat();

        const staticColumns = [
            selectedStaticFields.includes('Initial Action Date') && {
                accessorKey: 'created_at',
                header: 'Initial Action Date',
                Cell: ({ row }) => dateFormate(row?.original?.created_at),
            },
            // selectedStaticFields.includes('Last Action Date') && {
            //     accessorKey: 'last_status.updated_at',
            //     header: 'Last Action Date',
            //     Cell: ({ row }) => dateFormate(row?.original?.last_status?.updated_at),
            // },
            selectedStaticFields.includes('Current Status') && statusList?.length > 0 && {
                accessorKey: 'current_status', header: 'Current Status',
                Cell: ({ row }) => {
                    const currentStatusValue = useMemo(() => {
                        const statusName = row?.original?.last_status?.status_name;
                        return statusName ? { status_name: statusName } : null;
                    }, [row?.original?.last_status?.status_name]);

                    return (
                        <div key={`${row?.original?.id}-status`}> {/* Ensure unique key */}
                            <SearchableDropdown
                                size="small"
                                options={statusList} // Use local statusList
                                value={currentStatusValue}
                                onChange={(e) => handleUpdate(e, row?.original?.id)}
                                labelKey='status_name'
                                label={'Select Status'}
                            // Add key prop if needed for specific re-render control
                            />
                        </div>
                    )
                }
            },
            // selectedStaticFields.includes('Next Status') && statusList?.length > 0 && {
            //     accessorKey: 'next_status', header: 'Next Status',
            //     Cell: ({ row }) => {
            //         return (
            //             <Box key={row?.original?.id}>
            //                 <SearchableDropdown
            //                     size="small"
            //                     options={getNextStatusByStatus(row?.original?.last_status?.status_name)}
            //                     value={row?.original?.next_status?.status_name ? { name: row?.original?.next_status?.status_name } : null}
            //                     onChange={(e) => { handleUpdateNextStatus(e, row?.original?.id) }}
            //                     labelKey='name'
            //                     label={'Select Status'}
            //                 />
            //             </Box>
            //         )
            //     }
            // },
            // selectedStaticFields.includes('Next Action Date') && {
            //     accessorKey: 'next_action_date', header: 'Next Action Date',
            //     Cell: ({ row }) => (
            //         <DateTimeSubmitPicker
            //             key={`${row?.original?.id}-nextdate`} // Ensure unique key
            //             initialDateTime={row.original?.next_action_date ? new Date(row.original.next_action_date) : null}
            //             buttonLabel="Set Date" // Changed label slightly
            //             onSubmit={(newDate) => {
            //                 setPendingDateUpdate({ id: row.original?.id, date: newDate });
            //                 setConfirmDateOpen(true);
            //             }}
            //         />
            //     ),
            // },
            // selectedStaticFields.includes('Internal Comment') && {
            //     accessorKey: 'last_machadalo_comment.comment',
            //     header: 'Internal Comment',
            //     size: 140,
            //     Cell: CommentCell,
            // },
            {
                accessorKey: 'action',
                header: 'Action',
                enableSorting: false,
                size: 80,
                Cell: ({ row }: any) => {
                    const [anchorElAction, setAnchorElAction] = React.useState<null | HTMLElement>(null);
                    const actionOpen = Boolean(anchorElAction);
                    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => setAnchorElAction(event.currentTarget);
                    const handleClose = () => setAnchorElAction(null);

                    return (
                        <div>
                            <IconButton onClick={handleClick} size="small">
                                <MoreVertIcon />
                            </IconButton>
                            <Menu
                                anchorEl={anchorElAction}
                                open={actionOpen}
                                onClose={handleClose}
                            >
                                <MenuItem onClick={() => { handleClose(); setOpenCommentModal(true); setSelectedRow(row?.original); }}>
                                    Comment
                                </MenuItem>
                                <MenuItem onClick={() => { handleClose(); setOpenImageModal(true); setSelectedRow(row?.original); }}>
                                    Images
                                </MenuItem>
                                <MenuItem onClick={() => { handleClose(); setOpenFormDetailModal(true); setSelectedRow(row?.original); }}>
                                    Form Detail
                                </MenuItem>
                                <MenuItem onClick={() => { handleClose(); setOpenUpdateStatusModal(true); setSelectedRow(row?.original); }} >
                                    All Status
                                </MenuItem>
                                <MenuItem onClick={() => { setShowCallingModal(true); setSelectedRow(row?.original); }} >
                                    Quick  Call
                                </MenuItem>
                                <MenuItem onClick={() => { setConfirmDeleteOpen(true); setSelectedRow(row?.original); }}                                >
                                    Delete
                                </MenuItem>
                            </Menu>
                        </div>
                    );
                },
            },
        ].filter(Boolean);

        return [...baseColumns, ...dynamicColumns, ...staticColumns];
    }, [filters.page, filters.limit, selectedFields, selectedStaticFields, statusList, filterableFields, campaignId, leadFormId, campaignDataMap, leadsData]);

    const handleRefresh = () => {
        setDateRange({ startDate: null, endDate: null });
        setSelectedFields([]);
        setSelectedStaticFields(staticFieldOptions);
        setFilters({
            parent_lead_id: parentLead?.lead_id || '',
            campaign_id: "",
            leads_form_id: "",
            page: 0,
            limit: 10,
            search: '',
            status: '',
            statusObj: null,
            isPending: false,
            start_date: '',
            end_date: '',
            sort_by: 'created_at',
            sort_type: -1,
        });
    };

    useEffect(() => {
        if (sorting?.length > 0) {
            const { id, desc } = sorting[0];
            setFilters((prev) => ({
                ...prev,
                sort_by: id || 'created_at',
                sort_type: desc ? -1 : 1,
                page: 0, // Reset to first page on sort change
            }));
        } else {
            // Optional: Reset to default sort if sorting is cleared
            setFilters((prev) => ({
                ...prev,
                sort_by: 'created_at',
                sort_type: -1,
            }));
        }
    }, [sorting]);

    useEffect(() => {
        if (parentLead?.lead_id) {
            setFilters((prev) => ({
                ...prev,
                parent_lead_id: parentLead.lead_id,
                page: 0 // Optional: reset to page 0 on parent switch
            }));
        }
    }, [parentLead?.lead_id]);


    useEffect(() => {
        fetchLeads();
    }, [leadFormId, campaignId, parentLead?.lead_id]);

    useEffect(() => {
        setStatusFilters((prev) => ({ ...prev, leadFormId: leadFormId }));
        getStatusList({ ...statusFilters, leadFormId: leadFormId });
    }, [leadFormId]);

    const filterableFieldsRef = useRef([]);
    const statusListFetchedRef = useRef(false);

    useEffect(() => {
        setFilterableFields(dynamicFormFields || [])
        const updatedFilterableFields = dynamicFormFields?.flatMap((f) => {
            if (f.key_type === "ENTITY" && f?.selectedEntityFields?.length > 0) {
                return f.selectedEntityFields.map((entityField) => ({
                    ...f,
                    entityAliasName: entityField,
                }));
            } else {
                return [{ ...f }];
            }
        })
        setSelectedFields(updatedFilterableFields);
        // const selected = dynamicFormFields?.filter(item => item?.key_type !== 'ENTITY') || [];
        // setSelectedFields(selected);
    }, [dynamicFormFields])

    const [selectedLeads, setSelectedLeads] = useState < any[] > ([]);

    const confirmDeleteLeads = async (confirmed: boolean) => {
        if (confirmed && selectedLeads.length > 0) {
            try {
                // Assuming leadActions.deleteLeadV1 can accept multiple lead ids (adjust accordingly)
                const deletePromises = selectedLeads.map(lead => leadActions.deleteLeadV1(lead));
                const results = await Promise.all(deletePromises);

                const allSuccess = results.every(res => res?.status === 200);
                if (allSuccess) {
                    showSnackBar('Selected leads deleted successfully!', 'success');
                    // Remove deleted leads from state
                    const remainingLeads = leadsData.filter(lead => !selectedLeads.find(sl => sl.lead_id === lead.lead_id));
                    setLeadsData(remainingLeads);
                    setSelectedLeads([]);
                } else {
                    showSnackBar('Failed to delete some leads.', 'error');
                }
            } catch (error) {
                showSnackBar('Failed to delete leads.', 'error');
            }
        }
        setConfirmDeleteOpen(false);
    };


    return (
        <Box sx={{ padding: '15px', backgroundColor: '#f0f2f5', borderRadius: '8px', mt: 2, border: '1px solid #e0e0e0' }}>
            {/* Removed Breadcrumbs */}

            {/* Header Section */}
            <Box sx={{ padding: '15px', backgroundColor: '#f0f2f5', borderRadius: '8px', mt: 2, border: '1px solid #e0e0e0' }}>
                {/* Render the autofilled field, View More button and Create button in one row */}
                <Grid container alignItems="center" justifyContent="space-between">
                    <Grid item xs={8} sx={{ display: 'flex', alignItems: 'center' }}>
                        {/* Label for Auto Filled Fields */}
                        {/* <Typography variant="h6" fontWeight="bold" sx={{ mr: 2 }}>
                        Auto Filled Field :
                    </Typography> */}

                        {/* Display the autofilled field and View More button */}
                        {parentLead?.data?.length > 0 && (
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography variant="subtitle2" fontWeight="bold" sx={{ mr: 2 }}>
                                    {convertToReadableFormat(parentLead?.data[0]?.alias_name)}
                                </Typography>
                                <Typography variant="body2" sx={{ mr: 2 }}>
                                    {parentLead?.data[0]?.value}
                                </Typography>
                                {/* View More button */}
                                {parentLead?.data?.length > 1 && (
                                    <Button variant="outlined" onClick={handleViewMoreClick} size="small" sx={{ marginLeft: 2 }}>
                                        View More
                                    </Button>

                                )}

                            </Box>
                        )}
                    </Grid>

                    <Grid item xs={4} sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                        <Tooltip title="Create a new lead">
                            <span>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    onClick={() => {
                                        setOpenFormDetailModal(true);
                                        setSelectedRow(null);
                                    }}
                                >
                                    Add
                                </Button>
                            </span>
                        </Tooltip>

                        <Tooltip title={selectedLeads.length !== 1 ? 'Select one row to edit' : ''}>
                            <span>
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    size="small"
                                    disabled={selectedLeads.length !== 1}
                                    onClick={() => {
                                        setSelectedRow(selectedLeads[0]);
                                        setOpenFormDetailModal(true);
                                    }}
                                >
                                    Edit
                                </Button>
                            </span>
                        </Tooltip>

                        <Tooltip title={selectedLeads.length === 0 ? 'Select at least one row to delete' : ''}>
                            <span>
                                <Button
                                    variant="outlined"
                                    color="error"
                                    size="small"
                                    disabled={selectedLeads.length !== 1}
                                   onClick={() => {
                                     setSelectedRow(selectedLeads[0]);
                                     setConfirmDeleteOpen(true);
                                   }}
                                >
                                    Delete
                                </Button>
                            </span>
                        </Tooltip>
                    </Grid>


                </Grid>

                {/* Modal for View More */}
                <Modal open={openModal} onClose={handleCloseModal}>
  <Box sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxHeight: '80vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    position: 'relative', // important for the cross button
  }}>
    {/* Top-Right Cross Button */}
    <IconButton
      onClick={handleCloseModal}
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        zIndex: 1,
      }}
    >
      <CloseIcon />
    </IconButton>

    <Typography variant="h6" fontWeight="bold" sx={{ mb: 2 }}>
      Autofilled from Parent Dashboard
    </Typography>

    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      {parentLead?.data?.map((field: any) => {
        if (!field?.alias_name || !field?.value) return null;

        const readableLabel = convertToReadableFormat(field?.alias_name);
        const isEntity = field?.key_type === 'ENTITY';
        const entityData = isEntity && field?.value?.entity ? field.value.entity : null;

        return (
          <Box key={field.alias_name} sx={{ mb: 2 }}>
            <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 1 }}>
              {readableLabel}
            </Typography>

            {entityData ? (
              <Grid container spacing={2}>
                {Object.entries(entityData).map(([key, val]) => (
                  <Grid item xs={12} sm={6} key={key}>
                    <Typography variant="body2" color="textSecondary">
                      {convertToReadableFormat(key)}
                    </Typography>
                    <Typography variant="body1">
                      {val?.toString?.() || '-'}
                    </Typography>
                  </Grid>
                ))}
              </Grid>
            ) : (
              <Typography variant="body1">
                {field.value.toString?.() || '-'}
              </Typography>
            )}
          </Box>
        );
      })}
    </Box>

    {/* Bottom-Right Close Button */}
    <Box display="flex" justifyContent="flex-end" mt={4}>
      <Button variant="outlined" onClick={handleCloseModal} size="small">
        Close
      </Button>
    </Box>
  </Box>
</Modal>

              <Modal open={openMissingModal} onClose={() => setOpenMissingModal(false)}>
  <Box sx={{
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '80%',
    maxHeight: '80vh',
    overflowY: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: 2,
    position: 'relative',
  }}>
    {/* Top-right Close (X) button */}
    <IconButton
      onClick={() => setOpenMissingModal(false)}
      sx={{
        position: 'absolute',
        top: 8,
        right: 8,
        zIndex: 1,
      }}
    >
      <CloseIcon />
    </IconButton>

    <Typography variant="h6" fontWeight="bold" color="error" sx={{ mb: 2 }}>
      Missing Spare Parts
    </Typography>

    {(() => {
      const allSpareParts = [
        'Battery Management System (BMS)', 'Battery Connector', 'Battery Fuse',
        'Battery Pack', 'Cooling Fan', 'Lithium-ion Battery Cell',
        'Battery Balancer Circuit',
      ];

      const selectedSpareParts = Array.from(new Set(
        leadsData.flatMap((lead) =>
          (lead?.data || [])
            .map((field) => field?.value?.toString?.().trim())
            .filter((val) => val && allSpareParts.includes(val))
        )
      ));

      const missingSpareParts = allSpareParts.filter(part => !selectedSpareParts.includes(part));

      return missingSpareParts.length > 0 ? (
        <ul style={{ paddingLeft: '1.2em', marginTop: '0.8em' }}>
          {missingSpareParts.map(part => (
            <li key={part}>
              <Typography variant="body2">{part}</Typography>
            </li>
          ))}
        </ul>
      ) : (
        <Typography variant="body1" sx={{ mt: 2 }}>
          All spare parts are already selected 🎉
        </Typography>
      );
    })()}

    {/* Bottom-right Close button */}
    <Box display="flex" justifyContent="flex-end" mt={4}>
      <Button variant="outlined" onClick={() => setOpenMissingModal(false)} size="small">
        Close
      </Button>
    </Box>
  </Box>
</Modal>


            </Box>


            {/* Filter Section */}
            {/* <Grid container spacing={1} alignItems="center" sx={{ pb: 2, flexWrap: 'wrap' }}>
                <Grid item xs={12} sm={6} md={4}>
                    <SearchBox
                        handleSearch={handleSearch}
                        value={filters.search || ''}
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={3}>
                    <DateRangeFilter
                        onApply={handleDateRangeApply}
                        startDate={dateRange.startDate}
                        endDate={dateRange.endDate}
                    />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                    <SearchableDropdown
                        size="small"
                        options={statusList}
                        value={filters.statusObj || null} // Ensure value is null or object
                        onChange={(e) => {
                            setFilters((prev) => ({
                                ...prev,
                                page: 0,
                                statusObj: e,
                                status: e?.status_name || '',
                                isPending: false,
                            }));
                        }}
                        labelKey="status_name"
                        label="Filter by Status"
                    />
                </Grid>
                <Grid item xs={6} sm={3} md={1}>
                    <FormGroup>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={filters.isPending || false}
                                    onChange={(e) => {
                                        setFilters((prev) => ({
                                            ...prev,
                                            page: 0,
                                            statusObj: null,
                                            status: e.target.checked ? 'Pending' : '',
                                            isPending: e.target.checked,
                                        }));
                                    }}
                                    size="small"
                                />
                            }
                            label="Pending"
                        />
                    </FormGroup>
                </Grid>                
            </Grid> */}
            <Grid container spacing={2} alignItems="center" justifyContent="space-between" sx={{ p: 1 }}>
                {/* Left Side: Tab Label */}
                <Grid item xs="auto">
                    <Typography variant="subtitle1" fontWeight="bold">
                        {tabName || 'Form Name Dashboard'}
                    </Typography>
                </Grid>

                {/* Right Side: Buttons */}
                <Grid item xs sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, flexWrap: 'wrap' }}>
                    {filterableFields.length > 0 && (
                        <Button variant="outlined" onClick={handleOpenPopover} size="small">
                            Webform Cols
                        </Button>
                    )}
                    <Popover
                        open={open}
                        anchorEl={anchorEl}
                        onClose={handleClosePopover}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                        <Box sx={{ p: 2, maxHeight: 300, maxWidth: 250, overflowY: 'auto' }}>
                            <FormGroup>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={selectedFields.length >= filterableFields.length}
                                            indeterminate={
                                                selectedFields.length > 0 && selectedFields.length < filterableFields.length
                                            }
                                            onChange={(e) => {
                                                if (e.target.checked) {
                                                    const updatedFilterableFields = filterableFields?.flatMap((f) => {
                                                        if (f.key_type === "ENTITY" && f?.selectedEntityFields?.length > 0) {
                                                            return f.selectedEntityFields.map((entityField) => ({
                                                                ...f,
                                                                entityAliasName: entityField,
                                                            }));
                                                        } else {
                                                            return [{ ...f }];
                                                        }
                                                    })
                                                    setSelectedFields(updatedFilterableFields);
                                                } else {
                                                    setSelectedFields([]);
                                                }
                                            }}
                                            size="small"
                                        />
                                    }
                                    label={<Typography fontWeight="bold">Select All</Typography>}
                                />
                                {(sortFieldsByEntity(filterableFields) || [])?.map((field, index) => (
                                    field?.key_type !== "ENTITY"
                                        ? (
                                            <FormControlLabel
                                                key={field.alias_name ?? index}
                                                control={
                                                    <Checkbox
                                                        checked={selectedFields.some(f => f.alias_name === field.alias_name)}
                                                        onChange={() => handleFieldToggle(field)}
                                                        size="small"
                                                    />
                                                }
                                                label={field.label || field.alias_name}
                                            />
                                        )
                                        :
                                        <React.Fragment key={`entity-group-${field?.alias_name}-${index}`}>
                                            <Typography fontWeight="bold">{convertToReadableFormat(field?.alias_name || "Entity")}</Typography>
                                            {field?.selectedEntityFields?.map((entityField, entityIndex) => (
                                                <FormControlLabel
                                                    sx={{ pl: 2 }}
                                                    key={`entity-field-${field?.alias_name}-${entityField}-${entityIndex}`}
                                                    control={
                                                        <Checkbox
                                                            checked={selectedFields.some(f => f.entityAliasName === entityField)}
                                                            onChange={() => handleEntityFieldToggle(field, entityField)}
                                                            size="small"
                                                        />
                                                    }
                                                    label={convertToReadableFormat(entityField) || ''}
                                                />
                                            )
                                            )}
                                        </React.Fragment>
                                ))}

                            </FormGroup>
                        </Box>
                    </Popover>
                    <Button variant="outlined" onClick={handleOpenStaticPopover} size="small">
                        Static Cols
                    </Button>
                    <Popover
                        open={openStatic}
                        anchorEl={anchorStaticEl}
                        onClose={handleCloseStaticPopover}
                        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                    >
                        <Box sx={{ p: 2, maxHeight: 300, overflowY: 'auto' }}>
                            <FormGroup>
                                <FormControlLabel control={<Checkbox checked={selectedStaticFields.length === staticFieldOptions.length} indeterminate={selectedStaticFields.length > 0 && selectedStaticFields.length < staticFieldOptions.length} onChange={(e) => setSelectedStaticFields(e.target.checked ? staticFieldOptions : [])} size="small" />} label={<Typography fontWeight="bold">Select All</Typography>} />
                                {staticFieldOptions.map((field) => (<FormControlLabel key={field} control={<Checkbox checked={selectedStaticFields.includes(field)} onChange={() => handleStaticFieldToggle(field)} size="small" />} label={field} />))}
                            </FormGroup>
                        </Box>
                    </Popover>

                    {/* <IconButton onClick={handleRefresh} color="primary" size="small" disabled={isLoading}>
                    {isLoading ? <CircularProgress size={20} /> : <RefreshIcon />}
                </IconButton> */}
                </Grid>
            </Grid>
            {showSparePartsInfo && (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 2 }}>
                    <Typography variant="h6" color="error" fontWeight="bold">
                        {7 - leadsData.length} spare part{7 - leadsData.length !== 1 ? 's' : ''} missing
                    </Typography>
                    <Button
                        variant="outlined"
                        size="small"
                        color="error"
                        onClick={() => setOpenMissingModal(true)}
                    >
                        View Missing
                    </Button>
                </Box>
            )}


            <CommonTable
                columns={columns}
                data={leadsData}
                enableStickyHeader
                manualSorting
                onSortingChange={setSorting}
                getRowId={row => row.lead_id?.toString() || row.id?.toString()}
                enableRowSelection={true}
                onRowSelectionChange={(updater) => {
                    const prevRowSelection = Object.fromEntries(
                        leadsData.map((lead) => [lead.lead_id, selectedLeads.some((sl) => sl.lead_id === lead.lead_id)])
                    );
                    const newRowSelection =
                        typeof updater === 'function' ? updater(prevRowSelection) : updater;
                    const selected = leadsData.filter((lead) => newRowSelection[lead.lead_id]);
                    setSelectedLeads(selected);
                }}

                state={{ rowSelection: Object.fromEntries(selectedLeads.map(lead => [lead.lead_id, true])), isLoading: isLoading, sorting: sorting }}
                muiTableContainerProps={{ sx: { maxHeight: 'calc(100vh - 300px)' } }} // Adjust height as needed
                initialState={{ columnPinning: { right: ['action'] } }}
                renderBottomToolbar={() => (
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 0 }}>
                        <Pagination
                            totalCount={totalCount} // Use local totalCount
                            rowsPerPage={filters?.limit || 10}
                            page={filters.page}
                            handleChangePage={handleChangePage}
                            handleChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                    </Box>
                )}
            />

            {openCommentModal && (
                <ViewCommentModal
                    open={openCommentModal}
                    onClose={() => setOpenCommentModal(false)}
                    selectedRow={selectedRow}
                    onSaveComment={handleSaveCommentLocally} // Use local update handler
                />
            )}

            {openFormDetailModal &&
                <FormDetailsModal
                    open={openFormDetailModal}
                    dynamicFormGroups={dynamicFormGroups || []}
                    onClose={(data, type) => onCloseFormFieldsModal(data, type)}
                    selectedRow={selectedRow}
                    dynamicFormFields={filterableFields}
                    currentCampaignId={campaignId}
                    currentLeadFormId={leadFormId}
                    parentLead={parentLead}
                />}

            {openImageModal &&
                <ViewImagesModal
                    open={openImageModal}
                    onClose={() => setOpenImageModal(false)}
                    selectedRow={selectedRow}
                />}

            {openUpdateStatusModal &&
                <AllUpdateStatusModal
                    open={openUpdateStatusModal}
                    onClose={() => setOpenUpdateStatusModal(false)}
                    selectedRow={selectedRow}
                />}

            {/* Confirmation Dialogs */}
            <ConfirmBox
                open={confirmStatusOpen}
                onClose={(confirmed) => {
                    handleConfirmUpdate(confirmed);
                    setConfirmStatusOpen(false);
                }}
                options={{
                    title: 'Update Status',
                    text: 'Are you sure you want to update status?',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    confirmButtonColor: 'error',
                    cancelButtonColor: 'default',
                }}
            />

            <ConfirmBox
                open={confirmNextStatusOpen}
                onClose={handleConfirmNextStatusUpdate} // Use the new handler
                options={{ title: 'Update Next Status', text: 'Are you sure you want to update the next status?', confirmButtonText: 'Yes', cancelButtonText: 'No' }}
            />

            <ConfirmBox
                open={confirmDateOpen}
                onClose={handleConfirmDate} // Pass the handler directly
                options={{ title: 'Update Date', text: 'Are you sure?', confirmButtonText: 'Yes', cancelButtonText: 'No' }}
            />

            <ConfirmBox
                open={confirmDeleteOpen}
                onClose={(confirmed) => {
                    confirmDeleteLead(confirmed);
                    setConfirmDeleteOpen(false);
                }}
                options={{
                    title: 'Delete Lead',
                    text: 'Are you sure you want to delete this lead?',
                    confirmButtonText: 'Yes',
                    cancelButtonText: 'No',
                    confirmButtonColor: 'error',
                    cancelButtonColor: 'default',
                }}
            />

            {showCallingModal && (
                <ModalForms
                    show={showCallingModal}
                    handleClose={() => setShowCallingModal(false)}
                    modalBody={<CallingModal userDetails={{ phone_number: selectedRow?.phone_number || '' }} />}
                    modalHeader="Quick Call"
                    modalId="calling"
                    size="sm"
                />
            )}
            {/* Display Error */}
            {error && <Typography color="error" sx={{ mt: 2 }}>{error}</Typography>}
        </Box>
    );
};

export default ChildCampaignLeads;
